import { apiService } from "api/apiService";
import type { PortfolioStudentProgressGroupedResource } from "api/generated";
import { studentProgressGroupedFromDto } from "portfolio/api/mappers";
import type { MyStudentsProgress } from "portfolio/types";

export const fetchMentorClassPortfolio = async (
  mentorClass: string,
  params: Record<string, string> = {},
  signal?: AbortSignal,
): Promise<MyStudentsProgress> => {
  const url = `/api/my-students/${encodeURIComponent(mentorClass)}/portfolio`;

  const { data } =
    await apiService.get<PortfolioStudentProgressGroupedResource>(url, {
      params,
      signal,
    });

  return studentProgressGroupedFromDto(data);
};
